<template>
  <div class="tags" v-if="showTags">
    <ul>
      <li
        class="tags-li"
        v-for="(item, index) in tagsList"
        :key="index"
        :class="{'active': isActive(item.path)}"
        :style="{background:`${isActive(item.path) ? subjectColor : ''}`}"
      >
        <router-link :to="item.path" class="tags-li-title">{{item.title}}</router-link>
        <span class="tags-li-icon" @click="closeTags(index)">
          <i class="el-icon-close"></i>
        </span>
      </li>
    </ul>
    <div class="tags-close-box pt10">
      <el-dropdown @command="handleTags" style='margin-right:23px'>
        <el-button size="mini" style="border-radius: 2px !important;border: 1px solid #51CBCD;color: #51CBCD;">
          {{ $t('common', 'pageOptions') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu size="small" slot="dropdown">
          <el-dropdown-item command="other">{{ $t('common', 'closeOther') }}</el-dropdown-item>
          <el-dropdown-item command="all">{{ $t('common', 'closeAll') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import bus from "../../service/bus";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "commonTags",
  data() {
    return {
      tagsList: [],
    };
  },
  
  created() {
    this.setTags(this.$route);
    

    this.$store.watch(
      (state) => state.currentLanguage,
      (newLanguage, oldLanguage) => {
        if (newLanguage !== oldLanguage) {
          console.log('store language changed (backup):', newLanguage);
          this.updateTagsTitles();
        }
      }
    );
  },

  computed: {
    showTags() {
      return this.tagsList && this.tagsList.length > 0;
    },
    // 主题颜色
    subjectColor(){
      return this.$store.state.tagColor
    },
   
    currentLanguage() {
      return this.$store.state.currentLanguage || 'zh-TW';
    }
  },
  
  watch: {
    $route(newValue) {
      this.setTags(newValue);
    }
  },
  methods: {
    // 判断当前路由是否匹配当前tag
    isActive(path) {
      //详情页携带了id 所以需要去掉id再进行判断
      let str =  JSON.parse(JSON.stringify(this.$route.fullPath)),
      routePath = this.getStr(str)
      let cstr =  JSON.parse(JSON.stringify(path)),
      currentRoutePath = this.getStr(cstr)
      return currentRoutePath === routePath;
    },

    // 关闭标签
    closeTags(index) {
      let currentItem = this.tagsList.splice(index, 1)[0];
      let item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1];
      if (item) {
        currentItem.path === this.$route.fullPath &&
          this.$router.push(item.path);
      } else {
        this.$router.push("/dashboard");
      }
    },

    // 设置标签
    setTags(route) {
      let str = JSON.parse(JSON.stringify(route.fullPath)),
      routePath = this.getStr(str)

      if (this.tagsList.length > 0) {//length > 0
      let isExist = this.tagsList.find((item) => {
        let cstr = JSON.parse(JSON.stringify(item.path)),
        currentRoutePath = this.getStr(cstr)
        return currentRoutePath == routePath
      }); 
        if (this.tagsList.length >= 15) {
          this.tagsList.shift();
        }
        if(!isExist){//当没有重复的页面时
          this.tagsList.push({
            title: this.getRouteTitle(route),
            path: route.fullPath,
          });
        }else{//当有重复的页面时
          this.tagsList.forEach((item)=>{
             let cstr = JSON.parse(JSON.stringify(item.path)),
             currentRoutePath = this.getStr(cstr)
             if(currentRoutePath == routePath){
               item.path = route.fullPath
             }
          })

        }
      }else{
        this.tagsList.push({//length < 0
          title: this.getRouteTitle(route),
          path: route.fullPath,
        });
      }

      console.log('this.tagsList',this.tagsList)
      bus.$emit("tags", this.tagsList);
    },

    // 关闭其他选项
    handleCloseOther() {
      let currentItem = this.tagsList.filter((item) => {
        return item.path === this.$route.fullPath;
      });
      this.tagsList = currentItem;
    },

    // 关闭所有选项
    handleCloseAll() {
      this.tagsList = [];
      this.$router.push("/dashboard");
    },

    // 标签选项
    handleTags(val) {
      val === "other" ? this.handleCloseOther() : this.handleCloseAll();
    },
    getStr(string){ 
      var str_before = string.split('?')[0]; 
      return str_before
    },
    
    // 获取路由标题的多语言支持
    getRouteTitle(route) {
      console.log('getRouteTitle called for route:', route.path);
      console.log('route.meta:', route.meta);
      
      if (route.meta && route.meta.title) {
        const title = route.meta.title;
        console.log('title type:', typeof title, 'title value:', title);
        
        // 如果title是多语言对象
        if (typeof title === 'object' && title !== null) {
          const currentLanguage = this.$store.state.currentLanguage || 'zh-TW';
          const result = title[currentLanguage] || title['zh-TW'] || '';
          console.log('currentLanguage:', currentLanguage, 'result:', result);
          return result;
        }
        // 如果title是字符串，直接返回
        console.log('title is string, returning:', title);
        return title;
      }
      console.log('no title found, returning empty string');
      return '';
    },
    
    // 更新所有标签页标题
    updateTagsTitles() {

      this.tagsList.forEach(tag => {
        // 根据路径找到对应的路由
        const route = this.$router.resolve(tag.path).route;
        if (route) {
          const newTitle = this.getRouteTitle(route);
          console.log(`Updating tag ${tag.path}: "${tag.title}" -> "${newTitle}"`);
          if (newTitle && newTitle !== tag.title) {
            tag.title = newTitle;
          }
        }
      });
      
      // 强制更新视图
      this.$forceUpdate();
      
      // 重新发送标签列表到bus
      bus.$emit("tags", this.tagsList);
      
      console.log('tagsList after update:', JSON.stringify(this.tagsList.map(tag => ({ path: tag.path, title: tag.title }))));
    }
  },
};
</script>

<style scoped>
.tags {
  padding-top: 10px;
  position: relative;
  height: 50px;
  overflow: hidden;
  z-index: 1;
  background: #fff;
  padding-right: 120px;
  box-shadow: 0px 2px 6px rgba(115, 127, 128, 0.12);
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.tags-li {
  float: left;
  margin: 5px;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 26px;
  line-height: 28px;
  border: 1px solid #e9eaec;
  background: #fff;
  padding: 0 8px 0 15px;
  vertical-align: middle;
  color: #666;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  border-radius: 2px;
  min-width: 80px;
  max-width: 200px;
}

.tags-li .active .tags-li-icon {
  background-color: red;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}

.tags-li.active {
  color: #fff;
}

.tags-li-title {
  float: left;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 8px;
  color: #666;
  display: inline-block;
}

.tags-li.active .tags-li-title {
  color: #fff;
}

.tags-close-box {
  position: absolute;
  right: 5px;
  top: 0;
  box-sizing: border-box;
  text-align: center;
  height: 30px;
  z-index: 10;
}

/* .tags-li.active {
  border: 1px solid #6190e8;
  background-color: #6190e8;
} */
</style>
